import type { Ref } from 'react';
import { useEffect, useImperativeHandle } from 'react';

import type { WidgetRef } from '../types';
import { useWidgetContext } from './WidgetContext';

export const useWidgetSettingsHandler = (
  ref: Ref<WidgetRef>,
  openSettings: () => void
) => {
  useImperativeHandle(ref, (): WidgetRef => ({ openSettings }));

  const widgetContext = useWidgetContext();
  useEffect(() => {
    if (widgetContext?.pendingSettingsOpen) {
      openSettings();
      widgetContext.setPendingSettingsOpen?.(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [widgetContext?.pendingSettingsOpen]);
};
